import React, { FC } from 'react';
import { PageTitle, PublicPageWrapper } from '../../shared/components';
import { ResetPasswordForm } from '../components';

const ResetPasswordPage: FC = () => {
  return (
    <PublicPageWrapper resetPasswordPage>
      <PageTitle>Kies een wachtwoord</PageTitle>
      <ResetPasswordForm />
    </PublicPageWrapper>
  );
};

export default ResetPasswordPage;
